export default __webpack_public_path__ + "static/loading_product_icon_shoe-31442c5ba9854c3157bb5bc5fe478a22.png";